"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationProfile = void 0;
const types_1 = require("../main/types");
class ApplicationProfile extends types_1.ApplicationProfileType {
}
exports.ApplicationProfile = ApplicationProfile;
ApplicationProfile.converter = {
    toFirestore(data) {
        return {
            isPublic: data.isPublic,
            lastStudyDate: data.lastStudyDate,
            includedModuleCount: data.includedModuleCount,
            firstStudy: typeof (data.firstStudy) === "undefined" ?
                undefined : { status: data.firstStudy.status, date: data.firstStudy.date },
            firstAcquired: typeof (data.firstAcquired) === "undefined" ?
                undefined : { status: data.firstAcquired.status, date: data.firstAcquired.date },
            firstReview: typeof (data.firstReview) === "undefined" ?
                undefined : { status: data.firstReview.status, date: data.firstReview.date },
            autoGenExpiredAt: data.autoGenExpiredAt
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const userId = snapshot.id;
        const data = new ApplicationProfile(userId);
        data.isPublic = documentData.isPublic;
        data.lastStudyDate = documentData.lastStudyDate;
        data.includedModuleCount = documentData.includedModuleCount;
        data.firstStudy = documentData.firstStudy;
        data.firstAcquired = documentData.firstAcquired;
        data.firstReview = documentData.firstReview;
        data.autoGenExpiredAt = documentData.autoGenExpiredAt;
        return data;
    }
};
// export interface BooleanStatus {
//     status: boolean
//     date: Timestamp
//   }
